const AUTHENTICATION_ERRORS_MESSAGE_REGEXP = /.* code (401|403)/;

export const IGNORED_SENTRY_ERRORS = [AUTHENTICATION_ERRORS_MESSAGE_REGEXP];
